import React from 'react'

import { employersPaySchedules } from 'rails_routes'
import { Banner, Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

interface UnverifiedSchedulesHeaderBannerProps {
  /** Whether to show the CTA button */
  showCta?: boolean
}

export const UnverifiedSchedulesHeaderBanner: React.FC<UnverifiedSchedulesHeaderBannerProps> = ({
  showCta = false
}) => {
  const { assign } = useWindowLocation()

  return (
    <Banner
      type='warning'
      title='You have custom pay schedules to review'
      cta={showCta && (
        <Button
          variant='secondary'
          size='small'
          onClick={() => { assign(employersPaySchedules.index()) }}
        >
          View pay schedules
        </Button>
      )}
    >
      We've synced your company pay schedules from your payroll provider, but need you to review them to make sure future payroll deduction calculations are correct.
      <br />
      Until you've reviewed these new pay schedules, we'll keep using the default monthly schedule for your deductions.
    </Banner>
  )
}
